var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5944 15.5001C12.5944 13.895 13.8956 12.5938 15.5007 12.5938C17.1057 12.5938 18.4069 13.895 18.4069 15.5001C18.4069 17.1052 17.1057 18.4063 15.5007 18.4063C13.8956 18.4063 12.5944 17.1052 12.5944 15.5001Z",
    fill: "#9A9A9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.58398 15.5001C2.58398 17.6176 3.1329 18.3307 4.23072 19.757C6.42277 22.6048 10.099 25.8334 15.5007 25.8334C20.9023 25.8334 24.5785 22.6048 26.7706 19.757C27.8684 18.3307 28.4173 17.6176 28.4173 15.5001C28.4173 13.3826 27.8684 12.6694 26.7706 11.2432C24.5785 8.39534 20.9023 5.16675 15.5007 5.16675C10.099 5.16675 6.42277 8.39534 4.23072 11.2432C3.1329 12.6694 2.58398 13.3826 2.58398 15.5001ZM15.5007 10.6563C12.8255 10.6563 10.6569 12.825 10.6569 15.5001C10.6569 18.1752 12.8255 20.3438 15.5007 20.3438C18.1758 20.3438 20.3444 18.1752 20.3444 15.5001C20.3444 12.825 18.1758 10.6563 15.5007 10.6563Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.102dc291a15b11d7a61adec4ed091d8e.svg";
export { ForwardRef as ReactComponent };